// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import './router/moudles/beforeEach'
import Vuex from 'vuex'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './styles/index.scss'

import particles from 'particles.js'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

import animate from 'animate.css'
import commonUtil from '@/utils/commonUtil'
import { vueBaberrage } from 'vue-baberrage'
window._axiosPromiseArr = []
Vue.use(vueBaberrage)
Vue.use(animate)

Vue.use(ViewUI)
Vue.use(particles)
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.config.productionTip = true

Vue.prototype.$commonUtil = commonUtil
Vue.prototype.filterUnKnow = function (x) {
  // eslint-disable-next-line use-isnan
  if (x === null || x === undefined || x === NaN) {
    return '无数据'
  } else {
    return x
  }
}
Vue.prototype.$downloadJudge = function(x, y) {
  this.$message.closeAll()
  if (y === '' || y === null || y === ' ' || y === undefined) {
    this.$message({
      message: '未上传有效文件，无法下载',
      type: 'warning',
      offset: 100
    })
  } else {
    window.open(x)
  }
}

// 加入百度统计
var hm = document.createElement('script')
hm.src = 'https://hm.baidu.com/hm.js?' + process.env.TONGJI_ID
var s = document.getElementsByTagName('script')[0]
s.parentNode.insertBefore(hm, s)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js